<template>
    <div v-if="!loading" class="row justify-content-center">
        <div class="col-12 col-md-8">
            <ul class="list-group list-group-flush">
                <template v-if="parcelas.length > 0">
                    <li
                        v-for="parcela in parcelas"
                        :key="parcela.ticket_id"
                        class="list-group-item mb-2"
                        :class="parcela.detalle ? 'lightgray2-content' : ''"
                    >
                        <div class="row">
                            <div
                                class="col-12 d-flex justify-content-between"
                                @click="toggleDetalle(parcela)"
                                style="cursor: pointer;"
                            >
                                <span><b>{{ $t('perfil.nombre_abonado') }}: </b>{{ nombreCompleto(parcela) }}</span>
                                <span>
                                    <i :class="parcela.detalle ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
                                </span>
                            </div>
                            <transition name="fade" mode="out-in">
                                <div class="col-12" v-if="parcela.detalle">
                                    <div class="col-12 pt-4 pl-4 d-flex flex-column justify-content-between">
                                        <p><strong>{{ $t('perfil.pedido') }}:</strong> {{ parcela.n_pedido }}</p>
                                        <p><strong>{{ $t('perfil.email_compra') }}:</strong> <span class="text-wrap" style="word-break: break-all;">{{ parcela.datos_comprador.email }}</span></p>
                                        <p><strong>{{ $t('perfil.fecha_compra') }}:</strong> {{ parcela.fecha_compra }}</p>
                                        <p><strong>{{ $t('perfil.total_compra') }}:</strong> {{ parcela.price_total_pedido }} €</p>
                                        

                                        <div v-for="p in parcela.parcelas" :key="p.parcela_id" class="parcela-item">
                                            <hr/>
                                            <p><strong>{{ $t('perfil.numero_parcela') }}:</strong> {{ p.parcela_numero }}</p>
                                            <p><strong>{{ $t('perfil.zona') }}:</strong> {{ p.zona.nombre }}</p>
                                            <p><strong>{{ $t('perfil.precio') }}:</strong> {{ p.parcela_ticket.price }} €</p>
                                        </div>
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </li>
                </template>
                <li class="list-group-item text-center" v-else>
                    No hay parcelas disponibles.
                </li>
            </ul>
        </div>
    </div>
    <div style="padding: 50px;" v-else>
        <LoaderComponent />
    </div>
</template>

<script>
    export default {
        data() {
            return {
                parcelas: [],
                loading: false
            };
        },
        methods: {
            getParcelas() {
                this.loading = true;

                const params = {
                    filters: {}
                }

                this.$store.dispatch(this.config.getVuexAlias('front.perfil.parcelas'), params).then(res => {
                    this.parcelas = res.data.data.map(parcela => ({
                        ...parcela,
                        detalle: false
                    }));
                    console.log("console.log:", this.parcelas)
                }).finally(() => {
                    this.loading = false;
                });
            },
            toggleDetalle(parcela) {
                parcela.detalle = !parcela.detalle;
            }
        },
        created() {
            this.getParcelas();
        }, 
        computed: {
            nombreCompleto() {
                return item => {
                    if(!item.datos_comprador) return 'No hay datos disponibles';
                    const { nombre, apellidos } = item.datos_comprador;
            
                    if (!nombre && !apellidos) {
                        return 'Nombre no disponible';

                    }
                    
                    return `${nombre || ''} ${apellidos || ''}`.trim();
                };
            }
        }
    };
</script>